var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
import { normalizeWorkSpecification } from "../utils/workSpecificationUtils";
import { normalizePublisherGuarantors } from "../utils/guarantorRoles";
import { toPublisherActionError } from "../utils/publisherActionError";
import { ADDRESS_SUGGEST_LIMIT, isAddressSuggestQuery, } from "../utils/addressSuggestUtils";
/** Most publishers the list/search endpoints return in one page; the backend rejects a larger limit (DB-876). */
export var MAX_PUBLISHER_LIST_LIMIT = 100;
/** Default page size of the publisher list/search endpoints. */
var DEFAULT_PUBLISHER_LIST_LIMIT = 50;
var toPublisherListLimit = function (limit) {
    return Math.min(limit, MAX_PUBLISHER_LIST_LIMIT);
};
var formatDate = function (date) {
    return new Date(date).toISOString().split("T")[0];
};
var handleResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var text;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!response.ok) {
                    throw new Error("Error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.text()];
            case 1:
                text = _a.sent();
                return [2 /*return*/, text ? JSON.parse(text) : {}];
        }
    });
}); };
export var fetchRegions = function (kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("regions", { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, handleResponse(response)];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data.regions];
        }
    });
}); };
var isNotFoundError = function (error) {
    var _a;
    return typeof error === "object" &&
        error !== null &&
        ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404;
};
/**
 * Address suggestions for the typeahead. A query shorter than the backend minimum resolves to no
 * suggestions without a request (the backend would answer 400).
 */
export var fetchAddress = function (kyInstance, query) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1, data;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!isAddressSuggestQuery(query)) {
                    return [2 /*return*/, []];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("publisher-address/suggest", {
                        searchParams: { address: query.trim(), limit: ADDRESS_SUGGEST_LIMIT },
                        headers: getHeaders(),
                    })];
            case 2:
                response = _b.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _b.sent();
                // the backend answers 404 when RÚIAN has no match - that is "no suggestion", not a failure
                if (isNotFoundError(error_1)) {
                    return [2 /*return*/, []];
                }
                throw error_1;
            case 4:
                if (response.status === 404) {
                    return [2 /*return*/, []];
                }
                return [4 /*yield*/, handleResponse(response)];
            case 5:
                data = _b.sent();
                return [2 /*return*/, (_a = data.publisherAddresses) !== null && _a !== void 0 ? _a : []];
        }
    });
}); };
export var fetchAddressCode = function (kyInstance, addressCode) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("publisher-address/".concat(addressCode), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
/**
 * The last stop before a publisher is sent: every guarantor carries at most one publisher role, a legacy dual role
 * is sent as PublisherAdmin (DB-520) - the backend rejects a dual-role guarantor with 422.
 */
var withSingleGuarantorRoles = function (publisherData) {
    return (publisherData === null || publisherData === void 0 ? void 0 : publisherData.guarantors)
        ? __assign(__assign({}, publisherData), { guarantors: normalizePublisherGuarantors(publisherData.guarantors) }) : publisherData;
};
export var createPublisher = function (kyInstance, publisherData) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("publishers", {
                    json: withSingleGuarantorRoles(publisherData),
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
export var fetchPublisherData = function (id, kyInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("publishers/".concat(id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
export var fetchPublishers = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var name, companyNumber, startDate, endDate, _a, status, _b, offset, _c, limit, queryParts, statusQuery, searchParams, response, data;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                name = filters.name, companyNumber = filters.companyNumber, startDate = filters.startDate, endDate = filters.endDate, _a = filters.status, status = _a === void 0 ? [] : _a, _b = filters.offset, offset = _b === void 0 ? 0 : _b, _c = filters.limit, limit = _c === void 0 ? DEFAULT_PUBLISHER_LIST_LIMIT : _c;
                queryParts = [];
                if (name) {
                    queryParts.push("name=\"".concat(name, "*\""));
                }
                if (companyNumber) {
                    queryParts.push("companyNumber=\"".concat(companyNumber, "\""));
                }
                if (startDate) {
                    queryParts.push("birthDate>=\"".concat(formatDate(startDate), "\""));
                }
                if (endDate) {
                    queryParts.push("birthDate<=\"".concat(formatDate(endDate), "\""));
                }
                if (Array.isArray(status) && status.length > 0) {
                    statusQuery = status
                        .map(function (s) { return "status==\"".concat(s, "\""); })
                        .join(" or ");
                    queryParts.push(statusQuery);
                }
                searchParams = new URLSearchParams();
                if (queryParts.length > 0) {
                    searchParams.set("query", queryParts.join(" and "));
                }
                searchParams.set("limit", String(toPublisherListLimit(limit)));
                searchParams.set("offset", String(offset));
                return [4 /*yield*/, kyInstance.get("publishers", {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _d.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _d.sent();
                return [2 /*return*/, {
                        publishers: data.publishers,
                        totalRecords: data.totalRecords,
                    }];
        }
    });
}); };
export var searchPublishers = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var search, name, companyNumber, startDate, endDate, status, registrationAgency, registrationIntent, _a, offset, _b, limit, searchParams, response, data;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                search = filters.search, name = filters.name, companyNumber = filters.companyNumber, startDate = filters.startDate, endDate = filters.endDate, status = filters.status, registrationAgency = filters.registrationAgency, registrationIntent = filters.registrationIntent, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? DEFAULT_PUBLISHER_LIST_LIMIT : _b;
                searchParams = new URLSearchParams();
                if (search)
                    searchParams.append("search", search);
                if (name)
                    searchParams.append("name", name);
                if (companyNumber)
                    searchParams.append("companyNumber", companyNumber);
                if (startDate)
                    searchParams.append("birthDateFrom", formatDate(startDate));
                if (endDate)
                    searchParams.append("birthDateTo", formatDate(endDate));
                if (registrationAgency) {
                    searchParams.append("registrationAgency", registrationAgency);
                }
                if (registrationIntent) {
                    searchParams.append("registrationIntent", registrationIntent);
                }
                if (status && status.length > 0) {
                    status.forEach(function (s) { return searchParams.append("status", s); });
                }
                searchParams.append("limit", "".concat(toPublisherListLimit(limit)));
                searchParams.append("offset", "".concat(offset));
                return [4 /*yield*/, kyInstance.get("publishers/search", {
                        headers: getHeaders(),
                        searchParams: searchParams,
                    })];
            case 1:
                response = _c.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _c.sent();
                return [2 /*return*/, {
                        publishers: data.publishers,
                        totalRecords: data.totalRecords,
                    }];
        }
    });
}); };
export var updatePublisher = function (kyInstance, id, formValues) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.put("publishers/".concat(id), {
                    json: withSingleGuarantorRoles(formValues),
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
export var lookupPublisherByCompanyNumber = function (kyInstance, companyNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("publishers/".concat(companyNumber, "/lookup"), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
/** Translation ids of the failure of each publisher status action (RECEK-76282). */
var PUBLISHER_ACTION_FAILURE_MESSAGE_IDS = {
    close: "ui-br-publishers.publishers.error.close",
    closing: "ui-br-publishers.publishers.error.closing",
    confirmData: "ui-br-publishers.publishers.error.confirmData",
};
/** Runs a publisher status action; a failure is rethrown as a {@link PublisherActionError} with its message. */
var runPublisherAction = function (action, request) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 5]);
                _a = handleResponse;
                return [4 /*yield*/, request()];
            case 1: return [4 /*yield*/, _a.apply(void 0, [_b.sent()])];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                error_2 = _b.sent();
                return [4 /*yield*/, toPublisherActionError(error_2, PUBLISHER_ACTION_FAILURE_MESSAGE_IDS[action])];
            case 4: throw _b.sent();
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * Closes the publisher.
 *
 * @throws PublisherActionError carrying the message to show; a publisher user closing another publisher than the
 *         own one gets the foreign-publisher message (HTTP 403)
 */
export var closePublisher = function (kyInstance, publisherId, note) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, runPublisherAction("close", function () {
                return kyInstance.post("publishers/".concat(publisherId, "/close"), {
                    json: { internalComment: note },
                    headers: getHeaders(),
                });
            })];
    });
}); };
/**
 * Announces the closing of the publisher or confirms its data.
 *
 * @throws PublisherActionError carrying the message to show; a publisher user acting on another publisher than the
 *         own one gets the foreign-publisher message (HTTP 403)
 */
export var updatePublisherAction = function (kyInstance, publisherId, action) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, runPublisherAction(action, function () {
                return kyInstance.post("publishers/".concat(publisherId, "/").concat(action), {
                    headers: getHeaders(),
                });
            })];
    });
}); };
export var checkPublisherDuplicity = function (kyInstance, companyNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("publishers/".concat(companyNumber, "/checkDuplicity"), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
export var createPublisherRegistration = function (kyInstance, publisherId, registration) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("publishers/".concat(publisherId, "/registrations"), {
                    json: registration,
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
export var convertRegistrationToContinuous = function (kyInstance, publisherId, registrationId, withoutPrefixAssignment) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("publishers/".concat(publisherId, "/registrations/").concat(registrationId, "/convert-to-continuous"), __assign({ headers: getHeaders() }, (withoutPrefixAssignment
                    ? { searchParams: { withoutPrefixAssignment: "true" } }
                    : {})))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
export var takeOverPublisher = function (kyInstance, publisherId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("publishers/".concat(publisherId, "/take-over"), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
export var getDuplicities = function (kyInstance, formValues) { return __awaiter(void 0, void 0, void 0, function () {
    var cleanedValues, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cleanedValues = __assign(__assign({}, formValues), { workSpecification: formValues.workSpecification
                        ? normalizeWorkSpecification(formValues.workSpecification)
                        : formValues.workSpecification });
                return [4 /*yield*/, kyInstance.post("publishers/duplicities", {
                        json: cleanedValues,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
/**
 * The guarantor with the given e-mail. The e-mail is sent in the body of a POST, never in the URL - access logs
 * (sidecar, Kong, ingress) keep URLs (RECEK-76282, GDPR).
 */
export var fetchGuarantorByEmail = function (kyInstance, email) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("publisher-guarantors/lookup", {
                    json: { email: email },
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
/**
 * Whether the guarantor with the given e-mail is a guarantor of more publishers. The e-mail is sent in the body of a
 * POST, never in the URL (RECEK-76282, GDPR).
 */
export var fetchMultiGuarantorByEmail = function (kyInstance, email) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("publisher-guarantors/multi-guarantor", { json: { email: email }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, handleResponse(response)];
        }
    });
}); };
